import React, { useState } from "react";
import "./styles/FloatingContactButtons.css";
import CustomerSupportChatbot from "./CustomerSupportChatbot";

const FloatingContactButtons = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const handleWhatsAppClick = () => {
    // Replace with your company's WhatsApp number (include country code without + sign)
    const phoneNumber = "919821341221";
    const message = "Hello! I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleCallClick = () => {
    // Replace with your company's phone number
    const phoneNumber = "+919920850545";
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <>
      <div className="floating-contact-buttons">
        <button
          className="floating-btn chatbot-btn"
          onClick={() => setIsChatbotOpen(true)}
          title="AI Customer Support">
          <i className="fas fa-robot"></i>
        </button>
        <button
          className="floating-btn whatsapp-btn"
          onClick={handleWhatsAppClick}
          title="Contact us on WhatsApp">
          <i className="fa-brands fa-whatsapp"></i>
        </button>
        <button
          className="floating-btn call-btn"
          onClick={handleCallClick}
          title="Call us now">
          <i class="fa-solid fa-phone"></i>
        </button>
      </div>
      <CustomerSupportChatbot
        isOpen={isChatbotOpen}
        onClose={() => setIsChatbotOpen(false)}
      />
    </>
  );
};

export default FloatingContactButtons;
